<template>
  <van-overlay :show="isShowing" @click="isShowing = false" style="width:100%;display: flex;flex-direction: row;align-items: center;">
    <div style="width: 100%;position: relative;">
      <img :src="iconBg" style="width: 100%;" alt="">
      <div style="display: flex;flex-direction: column;position:absolute;
        bottom:38px;color:red;align-items: center;justify-content: center;width:100%;">
        <div style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
          <div v-if='showObj["Title"] != null && showObj["Title"] !== ""' :style="hcf.getTextStyle({
            marginBottom:25,addSize:10,color:'#E54127'
          })">{{showObj["Title"]}}</div>
          <div v-if='showObj["Title"] != null && showObj["Title"] === ""' :style="hcf.getTextStyle({
            marginBottom:24,addSize:13,color:'#E54127',fontWeight:'bold'
          })">{{showObj["Money"]}}{{' 元 '}}</div>
          <div :style="hcf.getTextStyle({
            marginBottom:25,addSize:3,color:'#A15E13'
          })">{{showObj["Desc"] ?? "恭喜老板"}}</div>
          <img @click="closeDialog" :src="iconBtn" style="width:60%;" alt="">
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<script setup>
  import { ref, onMounted, onUnmounted } from 'vue'
  import {emitter, hcf} from "@/components/utils/HComFunctions.js";
  import iconBg from "@/assets/icons/common/task_success_bg.png"
  import iconBtn from "@/assets/icons/common/task_success_btn.png"

  const isShowing = ref(false)
  const showObj = ref({
    "Visible": true,
    "Money": "1000",
    "Title": "",
    "Desc": "感谢参与下次加油",
  })

  const closeDialog = () => {
    isShowing.value = false
  }

  const setLoadingVisible = (obj) => {
    showObj.value = obj
    isShowing.value = obj.Visible ?? false
  }

  onMounted(() => {
    emitter.on('TASK_SUCCESS_VISIBLE', setLoadingVisible)
  })

  onUnmounted(() => {
    emitter.off('TASK_SUCCESS_VISIBLE', setLoadingVisible)
  })

  function getMoneyValue(val) {
    // 模拟 Global.getMoneyValue
    return Number(val).toFixed(2)
  }
</script>

<style scoped>
</style>
